import { Address } from './address';

export class PostalAddress extends Address {
  constructor(dataContext?: any) {
    super(dataContext);
    if (dataContext) {
      this.additionalName = dataContext.additionalName;
      this.name = dataContext.name;
    }
  }

  additionalName: string;
  name: string;
}
